import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { TabGeneric } from '../../compartidos/genericos/menu/TabGeneric'
import { DatosBancariosTab } from './menu/DatosBancariosTab'
import { CuentasContablesTab } from './menu/CuentasContablesTab'
import { getPlanesCuentas } from '../../../actions/contrataciones/contratacionesCartilla'
import { TIPO_EFECTORES } from '../../../utils/constants'

export const DatosContablesContrataciones = (props) => {
    const dispatch = useDispatch();

    const { planesCuentas } = useSelector((state) => state.contratacionesCartilla);
    const { dataContrato } = useSelector((state) => state.contrataciones);
    
    useEffect(() => planesCuentas.length === 0 && dispatch(getPlanesCuentas()), []);

    return (
        <>
            {dataContrato.idTipoEfector === TIPO_EFECTORES.PROVEEDOR ? (
                <TabGeneric 
                    tabs={[
                        {
                            name: "Datos Bancarios",
                            component: <DatosBancariosTab {...props} />
                        },
                        {
                            name: "Cuentas Contables",
                            component: <CuentasContablesTab {...props} />
                        }
                    ]} 
                />
            ) : (
                <DatosBancariosTab {...props} />
            )}
        </>
    )
}
